/**
 * Quest catalog + types. Quests are auto-accepted for every character (v1 — no quest-giver flow
 * yet): the server tracks per-objective progress off game events (questEvent), auto-completes a
 * quest when every objective hits its target, pays the cash reward, and syncs the whole log to the
 * owning client (MessageType.QuestLog). The client renders it in the M quest log (WoW-style:
 * expandable entries showing the description + objective progress).
 */
export const QUESTS = [
    {
        id: "first_introduction",
        title: "First Introduction",
        description: "Sal, a hooded wanderer who paces the BlackWater main road, took an interest in you. " +
            "Let him show you around the city — every traveller needs a first friend in Ghost Land.",
        objectives: [{ kind: "meet_giver", text: "Take Sal's tour of BlackWater city", target: 1 }],
        rewardCash: 6000,
        giver: "Sal",
    },
    {
        id: "old_timers_order",
        title: "The Old Timer's Order",
        description: "The Old Timer at OLD TIMER'S BAITS is restocking his bait tanks and pays good cash for " +
            "live pondfish. Catch 5 pondfish (the city pond is full of them) and bring them to him.",
        objectives: [{ kind: "submit_item", item: "pondfish", text: "Pondfish delivered", target: 5 }],
        rewardCash: 2000,
        giver: "Old Timer",
    },
    {
        id: "prized_imprint",
        title: "A Prized Imprint",
        description: "The Old Timer keeps BlackWater's fishing records on the old scroll in his shop. Bring him " +
            "any catch you're proud of and have it imprinted — the fish stays yours; only its size goes " +
            "down in the book.",
        objectives: [{ kind: "imprint_fish", text: "Fish imprinted", target: 1 }],
        rewardCash: 500,
        giver: "Old Timer",
        requires: "old_timers_order",
    },
];
export function questById(id) {
    return QUESTS.find((q) => q.id === id);
}
//# sourceMappingURL=quests.js.map